import { useEffect, useState } from "react";

// Reactive wrapper around navigator.onLine. Returns the current state and
// re-renders the consumer whenever the browser fires the online/offline
// event. Used by ChatPanel (disable Send while disconnected) and any future
// component that wants an offline indicator. The standalone global
// <OfflineBanner /> in PR 10 (Task 74) reuses this same hook.
//
// SSR safety: navigator is undefined during server-render or in Node test
// environments where the global isn't shimmed. We default to `true` in
// that case so the first paint doesn't flash the offline state.
export function useOnline(): boolean {
  const [online, setOnline] = useState<boolean>(
    typeof navigator === "undefined" ? true : navigator.onLine
  );
  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);
  return online;
}
